/*
 * 车行易工具库
 * @Author: 吴伟超
 * @Date: 2019-10-22 10:25:10
 * @Last Modified by: YC
 * @Last Modified time: 2024-09-25 11:02:29
 */

import ajax from './utils/ajax';

const hashNumber: number = parseInt(new Date().getTime() / 60000 + '', 10); // 当前hash值 缓存1分钟
const d: Document = document;
const plugins: string[] = ['advert', 'exposure'];
const pluginPath = 'https://oss.cx580.com/public_script/cxy-library/plugins/'; // 插件的路径
const pluginFuns: PluginFuns = {
  advert: {
    exist: 0,
    watcher: {}, // 监听中的广告位
    pending: {}, // 待监听的广告位
    on: (adCode: string, options: any, cb: any) => {
      const isRegistered = getPluginStaus('advert') === PluginStatus.REGISTERED;
      const key = isRegistered ? 'watcher' : 'pending';
      pluginFuns.advert[key][adCode] = { adCode, options, cb };
      if (isRegistered) pluginFuns.advert.fetch(adCode, options);
    },
    fetch: (adCode: string, options: any) => {
      if (pluginFuns.advert.api) {
        // 广告插件api准备好后，直接发起请求
        pluginFuns.advert.api(adCode, options);
      } else {
        console.error('advert.api is not defined');
      }
    }
  },
  exposure: {
    exist: 0,
    scrollFn: window.cxytjExposureScrollFn
  } // 曝光插件
};

let hash: boolean = false; // 是否开启hash
let registeredPlugins: string[] = []; // 已注册的插件
let pendingRegisterPlugins: string[] = []; // 待注册的插件
let syncLoad: boolean = false; // 是否同步加载

function addPlugin(names: string[]): number {
  if (names && names.length) {
    names.map(name => {
      if (plugins.indexOf(name) > -1) {
        if (syncLoad) {
          registeredPlugins.push(name);
          pendingRegisterPlugins = pendingRegisterPlugins.filter(
            pluginName => pluginName !== name
          );
          return;
        }
        requireJs(
          `${pluginPath}${name}.umd.js${hash ? '?t=' + hashNumber : ''}`,
          () => {
            registeredPlugins.push(name);
            pendingRegisterPlugins = pendingRegisterPlugins.filter(
              pluginName => pluginName !== name
            );
          },
          (err: any) => {
            console.error(`${name}插件加载失败,尝试动态引入`, err);
            d.head.insertAdjacentHTML('beforeend', `<script src="${pluginPath}${name}.umd.js${hash ? '?t=' + hashNumber : ''}"></script>`);
            setTimeout(() => {
              registeredPlugins.push(name);
              pendingRegisterPlugins = pendingRegisterPlugins.filter(
                pluginName => pluginName !== name
              );
            }, 0);
          }
        );
        pendingRegisterPlugins.push(name);
      } else {
        console.error(`${name}插件不存在`);
      }
    });
  }

  return pendingRegisterPlugins.length;
}

function getPluginStaus(name: string): PluginStatus {
  const isReg = registeredPlugins.indexOf(name) > -1;
  const isPend = pendingRegisterPlugins.indexOf(name) > -1;
  if (isReg) return PluginStatus.REGISTERED;
  if (isPend) return PluginStatus.PENDING;
  return PluginStatus.UNREGISTERED;
}

function plugin(pluginName: string) {
  if (plugins.indexOf(pluginName) === -1) return console.error(`${pluginName}插件不存在`);
  return pluginFuns[pluginName];
}

function requireJs(url: string, onload: any, onerror: any): void {
  if (url && d) {
    var hm = d.createElement('script');
    hm.src = url;
    hm.onload = onload;
    hm.onerror = onerror;
    var s = d.getElementsByTagName('script')[0];
    if (s && s.parentNode) s.parentNode.insertBefore(hm, s);
  } else {
    if (onerror) onerror('requireJs error');
  }
}

function init(options: CxyLibrary.AdvertConfig): void {
  hash = !!options.hash;
  syncLoad = !!options.syncLoad;
  if (options.plugins) addPlugin(options.plugins); // 新增插件
}

const cxyLibrary = {
  init,
  plugin,
  addPlugin,
  requireJs,
  ajax
};

export default cxyLibrary;
